import { AxiosRequestConfig, AxiosResponse } from "axios";
import axios from "src/utils/axios";
import qs from "qs"
import { PagedList } from "src/types/PagedList";

export abstract class BaseService {
    private readonly _controller: string;

    constructor(controller: string) {
        this._controller = `api/${controller}`;
    }

    protected async get<T = unknown>(url?: string, params?: unknown, config?: AxiosRequestConfig, signal?: AbortSignal): Promise<T> {
        const baseUrl = this._controller + "/" + (url ?? "");
        const response = await axios.get<T>(baseUrl, { params, paramsSerializer: params => qs.stringify(params), ...config, signal });
        return response.data;
    }

    public async paged<T>(url?: string, params?: unknown, signal?: AbortSignal): Promise<PagedList<T>> {
        const baseUrl = this._controller + "/" + (url ?? "");
        const response = await axios.get<PagedList<T>>(baseUrl, { params, signal });
        return response.data;
    }

    protected async post<T>(url: string, payload?: any, signal?: AbortSignal): Promise<AxiosResponse<T>> {
        const baseUrl = this._controller + "/" + (url ?? "");
        return await axios.post<T>(baseUrl, payload, { signal });
    }

    protected async put<T>(url: string, payload: any, signal?: AbortSignal): Promise<AxiosResponse<T>> {
        const baseUrl = this._controller + "/" + (url ?? "");
        return await axios.put<T>(baseUrl, payload, { signal });
    }

    protected async delete<T>(id: string, params?: any, signal?: AbortSignal): Promise<void> {
        const baseUrl = `${this._controller}/${id}`;
        await axios.delete<T>(baseUrl, { signal, params });
    }

    protected async patch<T>(url: string, payload: any, config?: AxiosRequestConfig, signal?: AbortSignal): Promise<void> {
        const baseUrl = this._controller + "/" + (url ?? "");
        await axios.patch<T>(baseUrl, payload, { ...config, signal });
    }
}